import { userApi } from "@/lib/userApi";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const rawUrl = (siteId, path) =>
  `${BACKEND}/api/cloner/sites/${siteId}/raw/${(path || "").replace(/^\//, "")}`;

export const zipUrl = (siteId) => `${BACKEND}/api/cloner/sites/${siteId}/zip`;

export const cloner = {
  pricing: () => userApi.get("/cloner/pricing"),
  sites: () => userApi.get("/cloner/sites"),
  site: (id) => userApi.get(`/cloner/sites/${id}`),
  create: (body) => userApi.post("/cloner/sites", body),
  rename: (id, name) => userApi.patch(`/cloner/sites/${id}`, { name }),
  stop: (id) => userApi.post(`/cloner/sites/${id}/stop`),
  remove: (id) => userApi.delete(`/cloner/sites/${id}`),
  files: (id) => userApi.get(`/cloner/sites/${id}/files`),
  text: (id, path) => userApi.get(`/cloner/sites/${id}/text`, { params: { path } }),
  save: (id, path, content) => userApi.put(`/cloner/sites/${id}/text`, { path, content }),
  aiEdit: (id, body) => userApi.post(`/cloner/sites/${id}/ai/edit`, body),
  aiAsk: (id, question) => userApi.post(`/cloner/sites/${id}/ai/ask`, { question }),
  aiHistory: (id) => userApi.get(`/cloner/sites/${id}/ai/history`),
  upload: (id, path, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return userApi.post(`/cloner/sites/${id}/upload?path=${encodeURIComponent(path)}`, fd);
  },
};

const EDITOR_CSS = `
[data-fx-hover]{outline:1px dashed #FF8A2B !important;outline-offset:1px}
[data-fx-sel]{outline:2px solid #e0352a !important;outline-offset:1px}
[data-fx-sel]::selection{background:#e0352a55}
`;

/** Prepara el HTML de una página para verse y editarse dentro del iframe. */
export const buildSrcDoc = (html, { siteId, path, js }) => {
  const dir = (path || "").split("/").slice(0, -1).join("/");
  const base = rawUrl(siteId, dir ? dir + "/" : "");
  let out = html.replace(/<base[^>]*>/gi, "");
  if (!js) out = out.replace(/<script\b[\s\S]*?<\/script>/gi, "");
  const head = `<base id="__fxbase" href="${base}"><style id="__fxstyle">${EDITOR_CSS}</style>`;
  if (/<head[^>]*>/i.test(out)) out = out.replace(/<head([^>]*)>/i, `<head$1>${head}`);
  else out = head + out;
  return out;
};

/** Devuelve el HTML limpio (sin las marcas del editor) listo para guardar. */
export const cleanHtml = (doc) => {
  const clone = doc.documentElement.cloneNode(true);
  clone.querySelectorAll("#__fxbase,#__fxstyle").forEach((n) => n.remove());
  clone.querySelectorAll("[data-fx-hover],[data-fx-sel]").forEach((n) => {
    n.removeAttribute("data-fx-hover");
    n.removeAttribute("data-fx-sel");
    n.removeAttribute("contenteditable");
  });
  return "<!DOCTYPE html>\n<html" + attrsOf(clone) + ">" + clone.innerHTML + "</html>";
};

const attrsOf = (el) =>
  Array.from(el.attributes)
    .map((a) => ` ${a.name}="${String(a.value).replace(/"/g, "&quot;")}"`).join("");

/** HTML de un elemento sin las marcas del editor (para la IA y la pestaña Código). */
export const cleanOuter = (el) => {
  if (!el) return "";
  const c = el.cloneNode(true);
  const all = [c, ...c.querySelectorAll("*")];
  all.forEach((n) => {
    n.removeAttribute?.("data-fx-sel");
    n.removeAttribute?.("data-fx-hover");
    n.removeAttribute?.("contenteditable");
  });
  return c.outerHTML;
};

export const describe = (el) => {
  if (!el) return "";
  const id = el.id ? `#${el.id}` : "";
  const cls = (el.className && typeof el.className === "string")
    ? "." + el.className.trim().split(/\s+/).slice(0, 2).join(".") : "";
  return `${el.tagName.toLowerCase()}${id}${cls}`.slice(0, 48);
};
